import {Component, Input, OnInit} from '@angular/core';
import {BaseRestaurant} from "../../../services/restaurant.service";
import {Constants} from "../../../utils/constants";

@Component({
  selector: 'app-slim-restaurant',
  templateUrl: './slim-restaurant.component.html',
  styleUrls: ['./slim-restaurant.component.scss']
})
export class SlimRestaurantComponent implements OnInit {

  @Input() restaurant:BaseRestaurant;
  public emailType = Constants.EMAIL_TYPES;
  constructor() { }

  ngOnInit() {
  }

}
